import enviroment from "../../enviroment";
import {rest} from "@/utils/utils";
// console.log('zdjApi');

export const logout = () => {
    let myHeaders = new Headers();
    myHeaders.append("Accept", "application/vnd.lichess.v5+json");
    myHeaders.append("X-Requested-With", "XMLHttpRequest");
    let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
        // body: {},
        credentials: 'include',
    };
    return fetch(`${enviroment.zdjUrl}api/ca/1/logout`, requestOptions)
        .then(function() {
            console.log('zdjService logout OK')
            return ({
                status: "ok",
                details: "",
            })
        })
        .catch(e=> {
            console.log('zdjService logout error', e)
            return ({
                status: "error",
                details: "cannot fetch",
            })
        })
}

export const login = (username, password) => {
    let myHeaders = new Headers();
    myHeaders.append("Accept", "application/vnd.lichess.v5+json");
    myHeaders.append("X-Requested-With", "XMLHttpRequest");
    myHeaders.append("Content-Type", "application/json");

    let raw = JSON.stringify({"username": username, "password": password, "token": "null"});
    let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
        credentials: 'include',
    };

    return new Promise((resolve, reject) =>  fetch(`${enviroment.zdjUrl}api/ca/1/login`, requestOptions)
        .then(function (response) {
            //console.log('got response',response)
            if (response.status !== 200 && response.status !== 204) {
                //console.log("No access")
                reject ({
                    error: "cannot login",
                    details: response.status,
                })
            }
            response.json().then(function (data) {
                //console.log('data:',data);
                if (data && data.sessionId) {
                    resolve ({
                        status: "ok",
                        details: response.status,
                    })
                } else {
                    reject ({
                        status: "error",
                        details: "no access"
                    })
                }
            }).catch(e => {
                reject ({
                    status: "error",
                    details: "cannot parse response"
                })
            })
        })
        .catch(e => {
            reject ({
                status: "error",
                details: "cannot fetch"
            })
        })
    );
}
